<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>{{ $route.params.id < 0 ? "Tambah" : "Ubah" }} Barang</h2>

      <div class="form-wrapper">
        <form @submit.prevent="save">
          <div class="form-group">
            <label>Nama Barang</label>
            <input type="text" v-model="data.nama" />
          </div>
          <div class="form-group">
            <label>Kategori</label>
            <select v-model="data.id_kategori">
              <option
                v-for="(item, index) in dataKategori"
                :key="index"
                :value="item.id"
              >
                {{ item.nama }}
              </option>
            </select>
          </div>

          <div class="input-harga">
            <div class="form-group">
              <label>Harga</label>
              <input
                type="text"
                v-model="data.harga_beli"
                @input="numFormat('harga_beli')"
              />
            </div>
            <div class="form-group">
              <label>Per</label>
              <input type="text" v-model="data.per" @input="numFormat('per')" />
            </div>
            <div class="form-group">
              <label>Satuan</label>
              <input type="text" v-model="data.satuan" />
            </div>
          </div>

          <div class="form-group">
            <label class="label-container">Pantau Stok
              <input type="checkbox" v-model="data.pantau_stok" :checked="data.pantau_stok" />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="form-group button">
            <button type="submit" class="btn-fill" :disabled="loadingButton">
              Simpan
            </button>
            <button type="button" class="btn-outline" @click="back()">
              Kembali
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/Api";
export default {
  name: "BahanBakuForm",
  components: {},
  data() {
    return {
      loading: false,
      loadingButton: false,
      data: [],
      dataKategori: [],
    };
  },
  methods: {
    loadKategori() {
      this.dataKategori = this.$store.state.kategori.data;
    },
    loadData() {
      this.loading = true;
      api
        .get("/v4/bahan-baku?id=" + this.$route.params.id)
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
    save() {
      this.loadingButton = true;
      this.data.id_toko = this.$toko.id;

      api
        .post("/v4/bahan-baku/save", this.data)
        .then((r) => {
          this.loadingButton = false;

          if (r.valid) {
            this.data.id = r.data.id;
            this.$store.commit("bahanBaku/add", this.data);
            this.$router.go(-1);
          } else {
            this.$toast("Gagal menyimpan data");
          }
        })
        .catch((e) => {
          this.loadingButton = false;
          this.$toast("Gagal menyimpan data");
        });
    },
    numFormat(model) {
      this.data[model] = this.$options.filters.number(
        this.data[model].replace(/\./g, "")
      );
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.loadKategori();

    this.data.id = null;
    if (this.$route.params.id > 0) {
      this.loadData();
      this.data.id = this.$route.params.id;
    }
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .form-wrapper {
    margin-top: 30px;
    form {
      width: 450px;
      .form-group.button {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 15px;
      }

      .input-harga {
        display: grid;
        grid-template-columns: 1fr 100px 100px;
        grid-column-gap: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/master/BahanBakuForm.vue